import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import {useCargosMutations} from '../../hooks/cargos/useCargosMutations'
import {getCargos} from "../../services/Cargos";

import DataTable from 'react-data-table-component';
import { NuevoCargo } from '../../components';


const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const Cargos = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeCargo} = useCargosMutations();
  const [sucursalesData, setSucursalesData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [CargoFiltro, setNombreCargoFiltro] = useState("");
  const [filteredData, setFilteredData] = useState([]);


  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getCargos();
      setSucursalesData(misSucursales);
    };
    fetchData();
  },[]);

  useEffect(() => {
    if (CargoFiltro.trim() === "") {
      setFilteredData(sucursalesData);
    } else {
      setFilteredData(
        sucursalesData.filter(item =>
          item.codigo && item.codigo.toLowerCase().includes(CargoFiltro.toLowerCase())
        )
      );
    }
  }, [CargoFiltro, sucursalesData]);

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevoCargo');
  };

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removeCargo.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
  
        const losFiados = await getCargos();
    
        setSucursalesData(losFiados);
      };
      fetchData();
    }

  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Código',
      selector: row => row.codigo,
      sortable: true
    },
    {
      name: 'Nombre',
      selector: row => row.nombreCargo,
      sortable: true
    },
    {
      name: 'Descripción',
      selector: row => row.descripcion,
      sortable: true
    },
    {
      name: 'Código ERP',
      selector: row => row.codigoERP,
      sortable: true
    },
    {
      name: 'Estado',
      selector: row => row.estado,
      sortable: true,
      cell: (row) => {
        let bgColor = '';
        switch ((row.estado || '').toUpperCase()) {
          case 'ACTIVO':
            bgColor = 'bg-green-100 text-green-700';
            break;
          case 'INACTIVO':
            bgColor = 'bg-yellow-100 text-yellow-700';
            break;
          case 'ELIMINADO':
            bgColor = 'bg-red-100 text-red-700';
            break;
          default:
            bgColor = 'bg-gray-100 text-gray-700';
        }
        return (
          <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
            {row.estado}
          </div>
        );
      }
    },
    {
      name: 'Fecha Creación',
      selector: row => row.fechaCreacion ? new Date(row.fechaCreacion).toLocaleDateString() : '',
      sortable: true
    },
  ];

  return (
    <>
    <div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Cargos
              </p>
            </div>
        </div>
      <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full justify-end">
            <div className="flex flex-col justify-end">
              <NavButton title="Agregar Cargo" customFunc={() => { setLaSucursal(''); handleClick('nuevoCargo')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={'Nuevo Cargo'} />
            </div>
            <div className="flex flex-col justify-end">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Código Cargo</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: CF-029"
                value={CargoFiltro}
                onChange={e => setNombreCargoFiltro(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

    <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
        <div className="flex flex-col">
          <DataTable
            columns={columns}
            data={filteredData}
            highlightOnHover={true}
            pagination={true}
            striped={true}
            selectableRowsHighlight={true}
            customStyles={customStyles}
            noHeader={true}
            noDataComponent={'No hay Cargos creados'}
          />
        </div>
      </div>
    </div>
     {isClicked.nuevoCargo && (<NuevoCargo vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}

  </div>
    </>

  );
};

export default Cargos;